import styled from 'styled-components/macro'

import { Card } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Container } from 'core/ui/Container'

import { screen } from 'legacy/styles/screen'

export const MainContent = styled(Container)`
  padding-top: ${getToken('space-l')};
  padding-bottom: ${getToken('space-l')};
`

export const HeaderWrapper = styled(Card)`
  padding-bottom: ${getToken('space-m')};
`

export const BookingConfirmationWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${screen.lg} {
    flex-wrap: unset;
  }
`

export const LoadSetupWrapper = styled.div`
  flex-basis: 100%;
  width: 100%;

  ${screen.lg} {
    flex-basis: 70%;
    width: 70%;
  }
`

export const ShipmentWrapper = styled.div`
  margin-top: ${getToken('space-s')};
  flex-basis: 100%;
  width: 100%;

  ${screen.lg} {
    margin-top: 0;
    margin-left: ${getToken('space-l')};
    flex-basis: 30%;
    width: 30%;
  }
`

export const StyledCard = styled(Card)`
  min-height: 400px;
  height: 100%;
`

export const RateconWrapper = styled.div`
  border-top: 1px solid ${getToken('color-neutral-light')};
  margin-top: ${getToken('space-m')};
  padding-top: ${getToken('space-m')};
  text-align: center;

  ${screen.md} {
    border-top: 0;
    margin-top: 0;
    padding-top: 0;
  }
`

export const TitleWrapper = styled.div`
  ${screen.md} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const StyledCardTitle = styled(Card.Title)`
  align-items: center;
  display: flex;
`

export const ShipmentTitle = styled.p`
  flex-grow: 1;
`

/** TODO: Refactor Card.Body, DatePicker: calendar is not shown if overflow is not initial on parent **/
export const StyledCardBody = styled(Card.Body)`
  overflow: initial;
`
